import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import helpers from "../helpers/index";

import route_helper from "../route-helper";
import { resetFamilyRedux } from "../helpers/helper-family-tree";

import ActivityIndicator from "../components/activity-indicator";
import ErrorSummary from "../components/error-summary";

import family_api from "../api/family-api";
import qs from 'qs'

import moment from 'moment'
import { radix_bases } from '../helpers/helper-number-bases';
import { patient } from "../model-states/m-family-tree";


class ReadOnlyPatients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      mrn: null,
      probands: [],
      errorMessages: [],
    };
    this.checkPatientId = this.checkPatientId.bind(this)
    this.removeLocalStorage  = this.removeLocalStorage.bind(this)
  }

  async componentDidMount() {
    helpers.setSiteTitle("EMR Patient Results");
    this.mounted = true
    //resetFamilyRedux(this.props.dispatch);

    // additional condition needed here if we always want to make emr just read only
    let emr_always_read_only = this.props.user.emr_always_read_only
    if (emr_always_read_only){
      sessionStorage.setItem('downgraded_to_read_only', true)
    }
    else{
      sessionStorage.setItem('downgraded_to_read_only', false)
    }

    await this.searchProbands()

  }

  async componentWillUnmount() {
    this.mounted = false
    // reset redux search when leaving this page

  }

  async searchProbands() {
    let probands = []
    let mrn, firstName, lastName, dob
    let payload = {}
    
    //change so when url with token entered patient is pulled up if one match, if multiple redirect here
    try {
      this.setState({ loading: true, errorMessages: [] });
      let query = qs.parse(this.props.location.search, {
        ignoreQueryPrefix: true
      })

      if(localStorage.getItem('encryptedData') && localStorage.getItem('signature')){
        payload = {
          "encryptedData": localStorage.getItem('encryptedData'),
          "signature": localStorage.getItem('signature'),
          "clinician_id": this.props.user.clinician_id
        }
      }else{
        let clean_mrn = JSON.stringify(query.mrn)
        let finalMrn
        clean_mrn = clean_mrn.replace(/['"]+/g, '')
        let indexOfUnwantedCharacter = clean_mrn.indexOf("\\");
        if(indexOfUnwantedCharacter >= 0){
          finalMrn = clean_mrn.slice(0,indexOfUnwantedCharacter)
        }else{
          finalMrn = clean_mrn
        }
        payload = {
         firstName: query.fname,
         lastName: query.lname,
         dob: query.dob,
         patientId: finalMrn,
         clinician_id: this.props.user.clinician_id,
  
        }
        mrn = query.mrn
      }
      probands = await family_api.get_emr_patients(payload, this.props.user.clinician_id)
      } catch (error) {
        helpers.logger(error);
        this.setState({ errorMessages: [error.message] });
      }finally{
        this.setState({probands: probands, mrn: mrn})
        if(this.mounted) {
          this.setState({ loading: false });
        }
      }

      //remove values from local storage
      this.removeLocalStorage()

      if(probands && probands.length === 1){
        this.viewPatient(probands[0],probands[0].id)
      }else if(probands == null || probands.length < 1){
        this.setState({errorMessages: ['No matching patients found.']})
      }


  }

  removeLocalStorage(){
    if (localStorage.getItem('signature')) {
      localStorage.removeItem('signature');
    }
    if (localStorage.getItem('encryptedData')) {
      localStorage.removeItem('encryptedData');
    }
    if (localStorage.getItem('fname')) {
      localStorage.removeItem('fname');
    }
    if (localStorage.getItem('lname')) {
      localStorage.removeItem('lname');
    }
    if (localStorage.getItem('dob')) {
      localStorage.removeItem('dob');
    }
    if (localStorage.getItem('finalMrn')) {
      localStorage.removeItem('finalMrn');
    }
    if(localStorage.getItem('finalMrn')){
      localStorage.removeItem('finalMrn')
    }
  }
  async viewPatient(proband, patient_id) {
    await this.checkPatientId(proband, this.state.mrn)
    helpers.delay(.3)
    const isIE = false || !!document.documentMode;
    let url =  isIE ?  route_helper.patient.patient_profile.replace(":member_id", patient_id) + "/#family-history": route_helper.pedigree.pedigree_root.replace(":member_id", patient_id) + "/#family-history" ;
    this.props.history.push(url);

  }

  getLocaleDateString(){
    var formats = { "ar-SA" : "DD/MM/YY", "bg-BG" : "DD.MM.YYYY", "ca-ES" : "DD/MM/YYYY", "zh-TW" : "YYYY/MM/DD", "cs-CZ" : "DD.MM.YYYY", "da-DK" : "DD-MM-YYYY", "de-DE" : "DD.MM.YYYY", "el-GR" : "DD/MM/YYYY", "en-US" : "MM/DD/YYYY", "fi-FI" : "DD.MM.YYYY", "fr-FR" : "DD/MM/YYYY", "he-IL" : "DD/MM/YYYY", "hu-HU" : "YYYY. MM. DD.", "is-IS" : "DD.MM.YYYY", "it-IT" : "DD/MM/YYYY", "ja-JP" : "YYYY/MM/DD", "ko-KR" : "YYYY-MM-DD", "nl-NL" : "DD-MM-YYYY", "nb-NO" : "DD.MM.YYYY", "pl-PL" : "YYYY-MM-DD", "pt-BR" : "DD/MM/YYYY", "ro-RO" : "DD.MM.YYYY", "ru-RU" : "DD.MM.YYYY", "hr-HR" : "DD.MM.YYYY", "sk-SK" : "DD. MM. YYYY", "sq-AL" : "YYYY-MM-DD", "sv-SE" : "YYYY-MM-DD", "th-TH" : "DD/MM/YYYY", "tr-TR" : "DD.MM.YYYY", "ur-PK" : "DD/MM/YYYY", "id-ID" : "DD/MM/YYYY", "uk-UA" : "DD.MM.YYYY", "be-BY" : "DD.MM.YYYY", "sl-SI" : "DD.MM.YYYY", "et-EE" : "DD.MM.YYYY", "lv-LV" : "YYYY.MM.DD.", "lt-LT" : "YYYY.MM.DD", "fa-IR" : "MM/DD/YYYY", "vi-VN" : "DD/MM/YYYY", "hy-AM" : "DD.MM.YYYY", "az-Latn-AZ" : "DD.MM.YYYY", "eu-ES" : "YYYY/MM/DD", "mk-MK" : "DD.MM.YYYY", "af-ZA" : "YYYY/MM/DD", "ka-GE" : "DD.MM.YYYY", "fo-FO" : "DD-MM-YYYY", "hi-IN" : "DD-MM-YYYY", "ms-MY" : "DD/MM/YYYY", "kk-KZ" : "DD.MM.YYYY", "ky-KG" : "DD.MM.YY", "sw-KE" : "MM/DD/YYYY", "uz-Latn-UZ" : "DD/MM YYYY", "tt-RU" : "DD.MM.YYYY", "pa-IN" : "DD-MM-YY", "gu-IN" : "DD-MM-YY", "ta-IN" : "DD-MM-YYYY", "te-IN" : "DD-MM-YY", "kn-IN" : "DD-MM-YY", "mr-IN" : "DD-MM-YYYY", "sa-IN" : "DD-MM-YYYY", "mn-MN" : "YY.MM.DD", "gl-ES" : "DD/MM/YY", "kok-IN" : "DD-MM-YYYY", "syr-SY" : "DD/MM/YYYY", "dv-MV" : "DD/MM/YY", "ar-IQ" : "DD/MM/YYYY", "zh-CN" : "YYYY/MM/DD", "de-CH" : "DD.MM.YYYY", "en-GB" : "DD/MM/YYYY", "es-MX" : "DD/MM/YYYY", "fr-BE" : "DD/MM/YYYY", "it-CH" : "DD.MM.YYYY", "nl-BE" : "DD/MM/YYYY", "nn-NO" : "DD.MM.YYYY", "pt-PT" : "DD-MM-YYYY", "sr-Latn-CS" : "DD.MM.YYYY", "sv-FI" : "DD.MM.YYYY", "az-Cyrl-AZ" : "DD.MM.YYYY", "ms-BN" : "DD/MM/YYYY", "uz-Cyrl-UZ" : "DD.MM.YYYY", "ar-EG" : "DD/MM/YYYY", "zh-HK" : "DD/MM/YYYY", "de-AT" : "DD.MM.YYYY", "en-AU" : "DD/MM/YYYY", "es-ES" : "DD/MM/YYYY", "fr-CA" : "YYYY-MM-DD", "sr-Cyrl-CS" : "DD.MM.YYYY", "ar-LY" : "DD/MM/YYYY", "zh-SG" : "DD/MM/YYYY", "de-LU" : "DD.MM.YYYY", "en-CA" : "DD/MM/YYYY", "es-GT" : "DD/MM/YYYY", "fr-CH" : "DD.MM.YYYY", "ar-DZ" : "DD-MM-YYYY", "zh-MO" : "DD/MM/YYYY", "de-LI" : "DD.MM.YYYY", "en-NZ" : "DD/MM/YYYY", "es-CR" : "DD/MM/YYYY", "fr-LU" : "DD/MM/YYYY", "ar-MA" : "DD-MM-YYYY", "en-IE" : "DD/MM/YYYY", "es-PA" : "MM/DD/YYYY", "fr-MC" : "DD/MM/YYYY", "ar-TN" : "DD-MM-YYYY", "en-ZA" : "YYYY/MM/DD", "es-DO" : "DD/MM/YYYY", "ar-OM" : "DD/MM/YYYY", "en-JM" : "DD/MM/YYYY", "es-VE" : "DD/MM/YYYY", "ar-YE" : "DD/MM/YYYY", "en-029" : "MM/DD/YYYY", "es-CO" : "DD/MM/YYYY", "ar-SY" : "DD/MM/YYYY", "en-BZ" : "DD/MM/YYYY", "es-PE" : "DD/MM/YYYY", "ar-JO" : "DD/MM/YYYY", "en-TT" : "DD/MM/YYYY", "es-AR" : "DD/MM/YYYY", "ar-LB" : "DD/MM/YYYY", "en-ZW" : "MM/DD/YYYY", "es-EC" : "DD/MM/YYYY", "ar-KW" : "DD/MM/YYYY", "en-PH" : "MM/DD/YYYY", "es-CL" : "DD-MM-YYYY", "ar-AE" : "DD/MM/YYYY", "es-UY" : "DD/MM/YYYY", "ar-BH" : "DD/MM/YYYY", "es-PY" : "DD/MM/YYYY", "ar-QA" : "DD/MM/YYYY", "es-BO" : "DD/MM/YYYY", "es-SV" : "DD/MM/YYYY", "es-HN" : "DD/MM/YYYY", "es-NI" : "DD/MM/YYYY", "es-PR" : "DD/MM/YYYY", "am-ET" : "DD/MM/YYYY", "tzm-Latn-DZ" : "DD-MM-YYYY", "iu-Latn-CA" : "DD/MM/YYYY", "sma-NO" : "DD.MM.YYYY", "mn-Mong-CN" : "YYYY/MM/DD", "gd-GB" : "DD/MM/YYYY", "en-MY" : "DD/MM/YYYY", "prs-AF" : "DD/MM/YY", "bn-BD" : "DD-MM-YY", "wo-SN" : "DD/MM/YYYY", "rw-RW" : "MM/DD/YYYY", "qut-GT" : "DD/MM/YYYY", "sah-RU" : "MM.DD.YYYY", "gsw-FR" : "DD/MM/YYYY", "co-FR" : "DD/MM/YYYY", "oc-FR" : "DD/MM/YYYY", "mi-NZ" : "DD/MM/YYYY", "ga-IE" : "DD/MM/YYYY", "se-SE" : "YYYY-MM-DD", "br-FR" : "DD/MM/YYYY", "smn-FI" : "DD.MM.YYYY", "moh-CA" : "MM/DD/YYYY", "arn-CL" : "DD-MM-YYYY", "ii-CN" : "YYYY/mM/DD", "dsb-DE" : "DD. MM. YYYY", "ig-NG" : "DD/MM/YYYY", "kl-GL" : "DD-MM-YYYY", "lb-LU" : "DD/MM/YYYY", "ba-RU" : "DD.MM.YY", "nso-ZA" : "YYYY/MM/DD", "quz-BO" : "DD/MM/YYYY", "yo-NG" : "DD/MM/YYYY", "ha-Latn-NG" : "DD/MM/YYYY", "fil-PH" : "MM/DD/YYYY", "ps-AF" : "DD/MM/YY", "fy-NL" : "DD-MM-YYYY", "ne-NP" : "MM/DD/YYYY", "se-NO" : "DD.MM.YYYY", "iu-Cans-CA" : "DD/MM/YYYY", "sr-Latn-RS" : "DD.MM.YYYY", "si-LK" : "YYYY-MM-DD", "sr-Cyrl-RS" : "DD.MM.YYYY", "lo-LA" : "DD/MM/YYYY", "km-KH" : "YYYY-MM-DD", "cy-GB" : "DD/MM/YYYY", "bo-CN" : "YYYY/MM/DD", "sms-FI" : "DD.MM.YYYY", "as-IN" : "DD-MM-YYYY", "ml-IN" : "DD-MM-YY", "en-IN" : "DD-MM-YYYY", "or-IN" : "DD-MM-YY", "bn-IN" : "DD-MM-YY", "tk-TM" : "DD.MM.YY", "bs-Latn-BA" : "DD.MM.YYYY", "mt-MT" : "DD/MM/YYYY", "sr-Cyrl-ME" : "DD.MM.YYYY", "se-FI" : "DD.MM.YYYY", "zu-ZA" : "YYYY/MM/DD", "xh-ZA" : "YYYY/MM/DD", "tn-ZA" : "YYYY/MM/DD", "hsb-DE" : "DD. MM. YYYY", "bs-Cyrl-BA" : "DD.MM.YYYY", "tg-Cyrl-TJ" : "DD.MM.YY", "sr-Latn-BA" : "DD.MM.YYYY", "smj-NO" : "DD.MM.YYYY", "rm-CH" : "DD/MM/YYYY", "smj-SE" : "YYYY-MM-DD", "quz-EC" : "DD/MM/YYYY", "quz-PE" : "DD/MM/YYYY", "hr-BA" : "DD.MM.YYYY.", "sr-Latn-ME" : "DD.MM.YYYY", "sma-SE" : "YYYY-MM-DD", "en-SG" : "DD/MM/YYYY", "ug-CN" : "YYYY-MM-DD", "sr-Cyrl-BA" : "DD.MM.YYYY", "es-US" : "MM/DD/YYYY" }
    return formats[navigator.language] || 'DD/MM/YYYY';
  }

async checkPatientId(patient, mrn){

  if(mrn && (patient.patient_id == null || patient.patient_id === "" ) && patient.patient_id !== mrn){
    try{

      this.setState({ loading: true, errorMessages: [] });
      let payload = {
        user: this.props.user,
        clinician_id: this.props.user.clinician_id,
        patient: patient,
        mrn: mrn
      }

      await family_api.update_patient_id_from_emr(payload)

    } catch (error) {
      helpers.logger(error);
      this.setState({ errorMessages: [error.message] });
    }finally{
      if(this.mounted) {
        this.setState({ loading: false });
      }
    }
   }
}

  render() {
    const tableRows = this.state.probands.map((patient, index) => (
      <tr key={index} role="row" onClick={() => {this.viewPatient(patient, patient.id)}}>
        <td>{patient.patient_id}</td>
        <td>{patient.last_name}</td>
        <td>{patient.first_name}</td>
        <td>{patient.gender}</td>
        <td>{moment(patient.dob).format(this.getLocaleDateString())}</td>
        <td>{moment(patient.modified_at).format(this.getLocaleDateString())}</td>
        <td className="middle">
          <button className="btn btn-light btn-xs table-btn-view margin-right-six" onClick={() => this.viewPatient(patient, patient.id)}><i className="fa fa-eye"></i>&nbsp;Select</button>
        </td>
      </tr>
    ));

    const currentUrl = window.location.href;

    const url = new URL(currentUrl);

    const urlParams = new URLSearchParams(url.search);

    const firstName = urlParams.get('fname');
    const lastName = urlParams.get('lname');
    const dob = urlParams.get('dob');
    const patientId = urlParams.get('mrn');

    const emr_dict = {
      firstName: firstName,
      lastName: lastName,
      dob: dob,
      patientId: patientId
    }

    return (
      <React.Fragment>
    {(this.state.errorMessages.length === 0) &&(
     <h4 className="emr-patient-search"> More than one patient matched on First name, Last name, and Date of Birth. Please select the correct patient.</h4>
     )}
        <section className="wow fadeIn emr-search-results">
          <div className="container">
            {!(this.state.errorMessages.includes('No matching patients found.')) && (
              <ErrorSummary errorMessages={this.state.errorMessages} />
            )}
            {(this.state.errorMessages.includes('No matching patients found.')) && (
              <div>
                <div class="alert alert-danger fade in" role="alert">
                  <h4>No matching patients found</h4>
                  <p>Verify the patient's name, date of birth, and patient ID are correct, or enter a new patient below.</p>
                </div>
                {(!this.props.user.has_read_only_role) && (
                <div>
                  <Link to={{
                    pathname: route_helper.patient.patient_root,
                    state: {"emr_dict": emr_dict},
                    }} className="btn btn-teal btn-md">
                    <i className="fa fa-plus text-white" />
                      <span>Enter New Patient</span>
                  </Link>
                  <br/>
                  <br/>
                </div>
                )}
              </div>
            )}

            <div className="row">
              <div className="col-md-12 col-sm-12 col-xs-12 center-col xs-no-padding">
                <table
                  className="display table-custom responsive no-wrap dataTable"
                  role="grid"
                >
                  <thead>
                    <tr role="row">
                      <th className="sorting_disabled">Patient ID</th>
                      <th className="sorting_disabled">Last Name</th>
                      <th className="sorting_disabled">First Name</th>
                      <th className="sorting_disabled">Gender</th>
                      <th className="sorting_disabled">DOB</th>
                      <th className="sorting_disabled">Last Modified</th>
                      <th className="sorting_disabled"> </th>
                    </tr>
                  </thead>

                  <tbody>{tableRows}</tbody>
                </table>
              </div>
            </div>
          </div>
      </section>

        <ActivityIndicator loading={this.state.loading} modal={true} />

      </React.Fragment>
    );
  }
}

const redux_state = state => ({
  user: state.session.user,
  searchFilter: state.search.searchFilter,
  session: state.session
});

const redux_actions = dispatch => ({
  dispatch: action => dispatch(action)
});

export default connect(
  redux_state,
  redux_actions
)(ReadOnlyPatients);
